const layoutConfig = {
  default: {
    sidebar: true,
    toolbar: true,
    footer: true,
    navbar: false,
  },
};

export default layoutConfig;
